import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/ui/Modal';

interface Props {
  open: boolean;
  onClose: () => void;
}

/** The facts the Digital SAT Math section provides on its reference sheet. */
const FORMULAS: Array<{ key: string; formula: string }> = [
  { key: 'circle_area', formula: 'A = πr²' },
  { key: 'circumference', formula: 'C = 2πr' },
  { key: 'rectangle', formula: 'A = ℓw' },
  { key: 'triangle', formula: 'A = ½bh' },
  { key: 'pythagorean', formula: 'c² = a² + b²' },
  { key: 'special_30_60', formula: 'x, x√3, 2x' },
  { key: 'special_45', formula: 's, s, s√2' },
  { key: 'box', formula: 'V = ℓwh' },
  { key: 'cylinder', formula: 'V = πr²h' },
  { key: 'sphere', formula: 'V = ⁴⁄₃πr³' },
  { key: 'cone', formula: 'V = ⅓πr²h' },
  { key: 'pyramid', formula: 'V = ⅓ℓwh' },
];

export function ReferenceSheet({ open, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={open} onClose={onClose} title={t('exam.sat.reference')} size="lg">
      <dl className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
        {FORMULAS.map((f) => (
          <div key={f.key} className="flex items-baseline justify-between gap-4 border-b border-gray-100 pb-2">
            <dt className="text-sm text-gray-600">{t(`exam.sat.ref.${f.key}`)}</dt>
            <dd className="font-serif text-base text-gray-900">{f.formula}</dd>
          </div>
        ))}
      </dl>
      <ul className="mt-5 space-y-1.5 text-sm text-gray-700">
        <li>{t('exam.sat.ref.fact_circle')}</li>
        <li>{t('exam.sat.ref.fact_radians')}</li>
        <li>{t('exam.sat.ref.fact_triangle')}</li>
      </ul>
    </Modal>
  );
}

export default ReferenceSheet;
